/**
 * @file SessionAuthProvider.tsx
 * @description
 * -----------------------------------------------------
 * Proveedor de contexto de la sesión de usuario
 * -----------------------------------------------------
 * @version 0.0.1a
 * @created 2025-03-12
 * @author Correcta
 * @copyright © Correcta
 * @license Private
 * */

"use client";

import { SessionProvider } from "next-auth/react";

interface Props {
  children: React.ReactNode;
}

const SessionAuthProvider = ({ children }: Props) => {
  return <SessionProvider>{children}</SessionProvider>;
};
export default SessionAuthProvider;
